<template>
  <v-footer

      app
      dark
  >
    <span class="white--text">Bazinga! &copy; {{ new Date().getFullYear() }}</span>
  </v-footer>
</template>

<script>
export default {
name: "Footer"
}
</script>

<style scoped>

</style>